import { render, staticRenderFns } from "./PsAdministration.vue?vue&type=template&id=21facbee&scoped=true&"
import script from "./PsAdministration.vue?vue&type=script&lang=js&"
export * from "./PsAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21facbee",
  null
  
)

export default component.exports